import { useState } from 'react';
import { useParams } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General question',
    body: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const { lang } = useParams();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await fetch('https://api.aronium.com/api/v1/message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error();
      }

      setIsSubmitted(true);
    } catch (err) {
      setError('Failed to send message. Please try again later.');
    }
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Contact - Aronium</title>
          <meta name="description" content="Stay in touch with Aronium team, ask questions or share your feedback" />
        </Helmet>
      </HelmetProvider>

      <div>
        <section className="py-8">
          <div className="container mx-auto text-center">
            <h1 className="text-4xl mb-4">Contact us</h1>
            <p>How can we help you today?</p>
          </div>
        </section>

        <div className="max-w-screen-xl mx-auto divide-y rounded divide-slate-200 px-4 mb-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-20">
            <div className="bg-white py-6">
              <h2 className="text-3xl mb-4">Office</h2>
              <p className="text-gray-600 mt-2"><strong>Aronium GmbH</strong></p>
              <p className="text-gray-600 mt-1">Akazienstraße 3a</p>
              <p className="text-gray-600 mt-1">10823 Berlin</p>
              <p className="text-gray-600 mt-1">Germany</p>
              <h3 className="text-lg text-gray-700 mt-6">Sales</h3>
              <a href="mailto:sales@aronium.com">sales@aronium.com</a>
              <h3 className="text-lg text-gray-700 mt-6">Support</h3>
              <a href="https://help.aronium.com/hc/en-us">Visit Help Center</a><br /><span className='text-gray-600'>or send an email to</span> <a href="mailto:support@aronium.com">support@aronium.com</a>

              <h3 className="text-lg text-gray-700 mt-6">Partners</h3>
              <p className="text-gray-600 mt-1">Find local partners on our <a href={`/${lang}/partners`}>partners page</a></p>
            </div>

            <div className="col-span-2 bg-white xl:py-6">
              <h2 className="text-3xl mb-4">Get in Touch</h2>
              {isSubmitted ? (
                <p className="text-green-600 font-semibold">Thank you! Your message has been sent successfully.</p>
              ) : (
                <form className="space-y-6 mt-6" onSubmit={handleSubmit}>
                  {error && <p className="text-red-600">{error}</p>}
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded-lg p-2.5 w-full focus:outline-none focus:ring focus:ring-blue-500"
                    placeholder="Full name *"
                    required

                  />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded-lg p-2.5 w-full focus:outline-none focus:ring focus:ring-blue-500"
                    placeholder="Email *"
                    required
                  />
                  <select name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded-lg p-2.5 w-full focus:outline-none focus:ring focus:ring-blue-500">
                    <option value="General question">General question</option>
                    <option value="Becoming a user">Becoming a user</option>
                    <option value="Feature request">Suggestion / Feature request</option>
                    <option value="Support request">Product support</option>
                  </select>

                  <div>
                    <textarea
                      name="body"
                      value={formData.body}
                      onChange={handleInputChange}
                      className="border border-gray-300 rounded-lg p-2.5 w-full focus:outline-none focus:ring focus:ring-blue-500"
                      rows="6"
                      placeholder="Your message *"
                      required
                      maxLength={300}
                    ></textarea>
                    <p className="text-sm text-gray-500 text-right">
                      {formData.body.length}/300 characters
                    </p>
                  </div>
                  <button
                    type="submit"
                    className="w-2/4 py-2 bg-sky-500 text-white rounded-full hover:bg-sky-600 focus:ring-4 focus:ring-blue-300 mx-auto block"
                  >
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;